/**
 * NoteIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const NoteIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m14 1.1.094.005.133.024.134.046.11.058.06.04.064.052 6.08 6.08.072.094.037.06.05.102.026.073.02.08q.02.09.02.186v12a2.9 2.9 0 0 1-2.9 2.9H6A2.9 2.9 0 0 1 3.1 20V4A2.9 2.9 0 0 1 6 1.1zm-.9 1.799L6 2.9A1.1 1.1 0 0 0 4.9 4v16A1.1 1.1 0 0 0 6 21.1h12a1.1 1.1 0 0 0 1.1-1.1V8.9H14a.9.9 0 0 1-.9-.9zM16 16.1a.9.9 0 1 1 0 1.8H8a.9.9 0 1 1 0-1.8zm0-4a.9.9 0 1 1 0 1.8H8a.9.9 0 1 1 0-1.8zm-6-4a.9.9 0 1 1 0 1.8H8a.9.9 0 0 1 0-1.8zm4.9-3.928V7.1h2.928z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const NoteIcon = makeIcon('NoteIcon', NoteIconSvg)
